// PDF report download — backend/routers/reports.py. No auth required.

import { config } from "../config";
import type { CityReportData } from "../types";

export function reportUrlFor(data: CityReportData): string {
  const radiusKm = data.radius_km ?? 100;

  if (data.city) {
    return `${config.apiBase}/report/${encodeURIComponent(data.city)}?radius_km=${radiusKm}`;
  }

  if (data.coords) {
    const [lat, lon] = data.coords;
    return `${config.apiBase}/report-by-coords?lat=${lat}&lon=${lon}&radius_km=${radiusKm}`;
  }

  throw new Error("No city or coordinates available for this report.");
}

export async function downloadReport(data: CityReportData): Promise<void> {
  const url = reportUrlFor(data);

  const res = await fetch(url);
  if (!res.ok) {
    throw new Error("Unable to generate the PDF. Please try again.");
  }

  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = "ev_report.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();

  URL.revokeObjectURL(objectUrl);
}
